// extracted by mini-css-extract-plugin
module.exports = {"itemsCountParent":"itemsCountParent--2eFtv","singleItemCount":"singleItemCount--1pwL_"};